import React, { useEffect, useRef, useState } from "react";
import { useBlade } from "../services/BladeProvider";
import EventOperations from "../services/EventOperations";
import apiService from "../services/apiService";
import { RaceDTO } from "../interfaces/RaceDTO";
import Loading from "../loader/Loading";
import ResultPage from "./results/ResultPage";
import { useFavorites } from "../services/FavoritesProvider";
import { ClockProvider } from "../services/ClockProvider";
import MobileResultPages from "./results/mobileviews/MobileResultPages";
import ErrorPage from "./ErrorPage";


const LivePage = () => {
  const {  setUserType,getMobileMode,setMobileMode,setAccesToken } = useBlade();
  const { addFavorite, setRaceID,setAthleteInfo } = useFavorites();
  const [raceid, setRaceid] = useState<number | null>(null);
  const [providerKey, setProviderKey] = useState<string | null>(null);
  let provKey: null | string = null;
  const refKey = useRef<string | null>(null);
  const [raceData, setRaceData] = useState<EventOperations | null>(null);
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("inget fel");
  useEffect(() => {
    let locStor = localStorage.getItem("user_type");
    let locToken = localStorage.getItem("user_token");
    if (locStor === null) {
      setUserType(null);
    } else {
      let obj = JSON.parse(locStor);
      setUserType(obj);
    }
    if (locToken) {
      setAccesToken(locToken);
    } 
    
    // setUserType()
    const params = new URLSearchParams(window.location.search);
    const raceid = params.get("raceid");
    const mobilemode = params.get("mobilemode");
    const timingprovider = params.get("timingkey");
    const favorites = localStorage.getItem("favorites_" + raceid);    
    const file = localStorage.getItem("athlete_info_" + raceid);    
    if (raceid !== null) {
      setRaceid(parseInt(raceid));
      setRaceID(parseInt(raceid));
    } else {
      setRaceid(null);
    }
    if (mobilemode !== null){
      if (mobilemode.toLocaleLowerCase() === "true" || mobilemode == "1"){
        setMobileMode(true);
      }
      else{
        setMobileMode(false);
      }
    }
    else{
      if (window.innerWidth < 750 || window.innerHeight < 400){
        setMobileMode(true);
      }
    }
    if (file){
      setAthleteInfo(JSON.parse(file));
    }

    if (timingprovider !== null) {
      setProviderKey((timingprovider));
      provKey = timingprovider;
      refKey.current = provKey;
    } else {
      setProviderKey(null);
      provKey = null;
      refKey.current = provKey;
    }
    if (favorites !== null) {
      const arrFavorites: number[] = JSON.parse(favorites);
      arrFavorites.map((av) => {
        addFavorite(av);
      });
    }
  }, []);
  useEffect(() => {
    // console.log(raceid, "Result ", " ava")

    if (raceid !== null) {
      const fetchData = async () => {
        // try {
        try {
          const result = await apiService.get<RaceDTO>(
            "/GetRaceMini/" +
              raceid +
              "?ApiKey=#apikey#&GetFields=TimePass&GetFields=Athletes&TimingProvider=" +
             (refKey.current ? refKey.current : "0a9afd9be94c9f567d86fa48c918bcd9")
          );
          let EvOP: EventOperations = new EventOperations(result);
          EvOP.startConnection();
          setRaceData(EvOP);
          document.title = "LS-Elite: " + result.Name;
        } catch (error) {
          console.log(error);
          setShowError(true);
          if (typeof error === "string") {
            setErrorMessage(
              "/GetRaceMini/" +
                raceid +
                "/?ApiKey=#apikey#&GetFields=TimePass&GetFields=Athletes&TimingProvider=" +
                (refKey
                  ? refKey
                  : "0a9afd9be94c9f567d86fa48c918bcd9") +
                " " +
                error.toUpperCase()
            ); // works, `e` narrowed to string
          } else if (error instanceof Error) {
            setErrorMessage(
              "/GetRaceMini/" +
                raceid +
                "/?ApiKey=#apikey#&GetFields=TimePass&GetFields=Athletes&TimingProvider=" +
                (provKey
                  ? provKey
                  : "0a9afd9be94c9f567d86fa48c918bcd9") +
                " " +
                error.message +
                " " +
                error.cause +
                " " +
                error
            ); // works, `e` narrowed to Error
          }
        }

        // console.log(JSON.stringify(result));

        // } catch (error) {
        //   console.error("Error fetching data", error);
        // }
      };
      fetchData();
    } else {
      if (raceData !== null) {
        raceData.stopConnection();
      }
    }
  }, [raceid]);

  if (showError) {
    return (
     <ErrorPage errorMessage={errorMessage} />
    );
  }

  if (localStorage.getItem("user_type") === null) {
  }
  return (
    <>
      {raceid === null || raceData?.eventData == null ? (
        <Loading />
      ) : (
        <ClockProvider>
          {getMobileMode() ? (<MobileResultPages raceid={raceid} key={raceid} race={raceData.eventData} /> )
          :<ResultPage raceid={raceid} key={raceid} race={raceData.eventData} timeScroll={raceData.TimeScroll} />
        }
          
        </ClockProvider>
      )}
    </>
  );
};

export default LivePage;
